"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MouthRegionGroup_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var MouthRegionGroup_Factory = /** @class */ (function () {
    function MouthRegionGroup_Factory() {
    }
    MouthRegionGroup_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    MouthRegionGroup_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return MouthRegionGroup_Factory;
}());
exports.MouthRegionGroup_Factory = MouthRegionGroup_Factory;
